import React from 'react'
import PropTypes from 'prop-types'
import AdvanceFilterSection from 'Components/SearchFilterFactory/AdvanceFilterSection'
import FormFactory from 'Components/SearchFilterFactory/PanelFormFactory'

const RenderFilterSection = (
  {
    filterLookup,
    searchQueryObj,
    googleAnalyticsEvent,
    isBasic = false,
    offer = '',
    showMobileVersion,
    filterOrders,
    orderType = '',
    lookups,
    isForSideBar,
    mobileFullPagePopup,
  }) => {
  const orders = filterOrders && filterOrders[orderType]
  const searchObj = { ...searchQueryObj, mode: searchQueryObj.mode || lookups.mode }
  if(!orders) return null
  return orders.map(order => {
    const children = []
    order.fields.forEach(filterKey => {
      let filter = filterLookup[filterKey]
      if(!filter) return null
      // currently only mode filter comes as array
      if(Array.isArray(filter)) {
        filter.forEach(f => {
          const hideOnData = f.hideOn[filterKey]
          let shouldShow = true
          if(hideOnData) {
            hideOnData.forEach(hide => {
              if(hide.toLowerCase() === offer?.toLowerCase()) {
                shouldShow = false
              }
            })
          }
          if(shouldShow) filter = f
        })
      }
      const { componentData, componentName, hideOn } = filter
      if(!filter.hide) {
        const props = {
          isBasic,
          componentData,
          componentName,
          inputName: filterKey,
          section: filterKey,
          hideOn,
          searchQueryObj: searchObj,
          mobileFullPagePopup,
          googleAnalyticsEvent,
          gaFromComponent: filter?.title,
          gaFromPage: 'search',
        }
        children.push(<FormFactory key={filterKey} {...props} />)
      }
    })
    if(!children.length) return null
    // basic should not show title
    if(isBasic) {
      return children
    }
    return (
      <AdvanceFilterSection
        showMobileVersion={showMobileVersion}
        sectionTitle={order.title}
        isForSideBar={isForSideBar}
      >
        {children}
      </AdvanceFilterSection>
    )
  })
}
RenderFilterSection.propTypes = {
  filterLookup: PropTypes.shape({}),
  googleAnalyticsEvent: PropTypes.func,
  isBasic: PropTypes.bool,
  isForSideBar: PropTypes.bool,
  offer: PropTypes.string,
  orderType: PropTypes.oneOf(['special', 'basic', 'advanced']),
  showMobileVersion: PropTypes.bool,
  filterOrders: PropTypes.shape({}),
  lookups: PropTypes.shape({
    mode: PropTypes.string,
  }),
  searchQueryObj: PropTypes.shape({
    mode: PropTypes.string,
  }),
  mobileFullPagePopup: PropTypes.bool,
}
export default RenderFilterSection
